import { UserMessageThread } from '@rse/core'
import { usePersistentCollectionItem } from './usePersistentCollectionItem'

export function useUserMessageThread({ uid, threadId }: { uid: string, threadId: string }) {
  return usePersistentCollectionItem<UserMessageThread>(`/userProfiles/${uid}/messageThreads/${threadId}`)
}
